<script>
export default {
  name: "BtnApplication",
  methods:{
    scrollTop(){
      if (window.innerWidth <= 700){
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#lead-form").offset().top -10
        }, 0);
      }
      else{
        $([document.documentElement, document.body]).animate({
          scrollTop: $("#lead-form").offset().top -30
        }, 0);
      }
    },
    scrollTopTop(){
      $([document.documentElement, document.body]).animate({
        scrollTop: $("header").offset().top - 50
      }, 0);

    }
  }
}
</script>

<template>
  <div class="btn-lead left flex flex-x-center mobile-nv" @click.prevent="scrollTop()">
    <a class="blue-btn left mobile-nv" >Оставить заявку на звонок </a>
  </div>
  <div class="btn-lead left flex flex-x-center mobile">
    <a class="btn-back-mob left mobile " @click.prevent="scrollTopTop()">Наверх </a>
  </div>
</template>

<style scoped>

</style>